export const stickerDisplayEnglish = {
  LABEL_ORG_FEATURE_STICKERS: "Stickers",
  LABEL_ORG_FEATURE_STICKERS_DESC:
    "Stickers on posts. While it is off, stickers are hidden everywhere and nobody can add new ones.",
  LABEL_STICKER_ADDED_BY: "Added by {{name}}",
  LABEL_STICKER_ADDED_BY_YOU: "Added by you",
  LABEL_STICKER_ADDED_BY_SOMEONE: "Added by a club member",
};

export const stickerDisplayGerman = {
  LABEL_ORG_FEATURE_STICKERS: "Sticker",
  LABEL_ORG_FEATURE_STICKERS_DESC:
    "Sticker auf Beiträgen. Ist die Funktion aus, sind Sticker überall ausgeblendet und niemand kann neue hinzufügen.",
  LABEL_STICKER_ADDED_BY: "Hinzugefügt von {{name}}",
  LABEL_STICKER_ADDED_BY_YOU: "Von dir hinzugefügt",
  LABEL_STICKER_ADDED_BY_SOMEONE: "Von einem Club-Mitglied hinzugefügt",
};
